// import React, { useEffect, useRef, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { BiArrowBack } from 'react-icons/bi';
// import { apiGET, apiPOST, apiPUT } from '../utilities/apiHelpers';
// import { useDispatch, useSelector } from 'react-redux';
// import { apiDELETE } from '../utilities/apiHelpers';
// import { toast } from 'react-toastify';
// import { setCartCount } from '../redux/users/users';
// import { API_URL } from '../config';


// const PaymentSuccess = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch()
//   const location = useLocation();
//   const hasFetched = useRef(false);
//   const [loading, setLoading] = useState(false);
//   const [data, setData] = useState(null);
//   const userId = useSelector((state) => state.user.userData.id) || ''

//   const getSessionInfo = async (sessionId) => {

//     try {
//       setLoading(true);
//       const response = await apiGET(`/v1/payment/get-session-info/${sessionId}`);
//       if (response.status) {
//         setData(response?.data?.data?.paymentIntent);
//         if (response?.data?.data?.metadata?.orderId) {
//           fetchOrderToRemoveCart(response?.data?.data?.metadata?.orderId)
//           const updatePayload = {
//             mode: response?.data?.data?.metadata?.orderMode,
//             orderType: response?.data?.data?.metadata?.orderType,
//             status: 'paid'
//           }
//           try {
//             const orderUpdateResponse = await apiPUT(`${API_URL}/v1/order/update/${response?.data?.data?.metadata?.orderId}`, updatePayload)
//             if (orderUpdateResponse?.status) {
//             }
//           } catch (error) {
//             toast.error('Failed to update order')
//           }
//         }
//         console.log("session data", response?.data?.data);
//         handlePaymentHistory(response?.data?.data?.paymentIntent)
//       }
//     } catch (error) {
//       console.error('Error fetching session info: ', error);
//       toast.error('Error fetching session info');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchOrderToRemoveCart = async (id) => {
//     try {
//       const orderResponse = await apiGET(`${API_URL}/v1/order/${id}`)
//       console.log('fetchOrderToRemoveCart', orderResponse?.data);
//       if (orderResponse?.status) {
//         if (orderResponse?.data.data[0].mode !== 'enquiry' && orderResponse?.data.data[0].status !== 'paid') {
//           console.log("Inside orderResponse?.data.data[0].mode !== 'enquiry'");
//           deleteUserStepperProgress()
//         }
//       }
//     } catch (error) {
//       toast.error('Failed to fetch order')
//     }
//   }

//   const deleteUserStepperProgress = async () => {
//     try {
//       setLoading(true);
//       const payload = {
//         selectedAddress: null,
//         selectedPrescription: null,
//         cartData: [],
//         currentStep: 0
//       }
//       const response = await apiPUT(`/v1/stepper-progress/update-stepper-progress/${userId}`, payload);
//       if (response.status) {
//         try {
//           const response = await apiDELETE(`/v1/cart/remove-user-cart`);
//           if (response.status) {
//             console.log(response.data.data);
//             dispatch(setCartCount(0))
//           } else {
//             console.log(response.data);
//           }
//         } catch (error) {
//           toast.error('Error Removing Cart')
//         }
//         console.log("Delete response", response.data.data);
//       }
//     } catch (error) {
//       console.error('Error fetching delete response info: ', error);
//       toast.error('Error fetching session info');
//     } finally {
//       setLoading(false);
//     }
//   }

//   const handlePaymentHistory = async (data) => {
//     console.log('Payment History???', data);
//     try {
//       const params = new URLSearchParams(location.search);
//       const session_id = params.get('session_id');
//       console.log("History required", userId, session_id);
//       const paymentHistoryPayload = {
//         "userId": userId,
//         "amount": 233,
//         "status": data?.status,
//         "currency": data?.currency,
//         "paymentId": data?.id,
//         "session_id": session_id,
//         "receipt_email": data?.receipt_email,
//         "payment_method_types": data?.payment_method_types[0]
//       }
//       const historyResponse = await apiPOST(`${API_URL}/v1/payment-history/add`, paymentHistoryPayload)
//       if (historyResponse?.data?.status) {
//         console.log("payment history add success")
//       } else {
//         console.log("payment history add error")
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   useEffect(() => {
//     if (hasFetched.current) return;
//     hasFetched.current = true;

//     const params = new URLSearchParams(location.search);
//     const sessionId = params.get('session_id');
//     if (sessionId) {
//       getSessionInfo(sessionId);
//     }
//   }, [location]);

//   const formatCurrency = (amount, currency) => {
//     let symbol = '';
//     switch (currency) {
//       case 'usd':
//         symbol = '$';
//         break;
//       case 'inr':
//         symbol = '₹';
//         break;
//       default:
//         symbol = currency?.toUpperCase();
//     }
//     return `${symbol}${(amount / 100).toFixed(2)}`;
//   };

//   return (
//     <div className="flex justify-center items-center p-4 font-poppins">
//       {loading ? (
//         <div className="spinner-border animate-spin inline-block w-12 h-12 border-4 rounded-full text-green-600"></div>
//       ) : (
//         <div className="bg-gray-100 rounded-lg p-6">
//           <div className="md:flex md:items-center md:space-x-6">
//             <div className="md:w-1/2">
//               <h2 className="text-2xl font-semibold mb-4">Payment confirmed successfully!</h2>
//               <p className="text-gray-600 text-lg mb-6">
//                 Thank you for your payment! Your transaction is confirmed. If there's anything you need to know, please don't hesitate to reach out to us!
//               </p>
//               <button
//                 onClick={() => navigate('/')}
//                 className="flex items-center bg-green-600 text-white py-2 px-4 rounded-lg"
//               >
//                 <BiArrowBack className="mr-2" /> Go back to home
//               </button>
//             </div>
//             <div className="md:w-1/2 mt-6 md:mt-0 bg-white p-6 rounded-lg shadow">
//               <h2 className="text-2xl font-semibold mb-4 text-center">
//                 {data && formatCurrency(data.amount, data.currency)}
//               </h2>
//               <p className="text-green-600 text-lg mb-6 text-center">Payment success!</p>
//               <div className="text-left">
//                 <h4 className="text-lg font-semibold mb-2">Payment details</h4>
//                 <p className="text-sm text-gray-600 mb-2">
//                   Date: <span className="font-semibold">{data && new Date(data.created * 1000).toLocaleString()}</span>
//                 </p>
//                 <p className="text-sm text-gray-600 mb-2">
//                   Reference number: <span className="font-semibold">{data && data.id}</span>
//                 </p>
//                 <p className="text-sm text-gray-600 mb-2">
//                   Amount: <span className="font-semibold">{data && formatCurrency(data.amount, data.currency)}</span>
//                 </p>
//                 <p className="text-sm text-gray-600 mb-2">
//                   Payment status: <span className="font-semibold text-green-600">{data && 'Success'}</span>
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // export default PaymentSuccess;
// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { BiArrowBack } from "react-icons/bi";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";

// import { apiGET, apiPOST, apiPUT, apiDELETE } from "../utilities/apiHelpers";
// import { setCartCount } from "../redux/users/users";
// import { API_URL } from "../config";

// const PaymentSuccess = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();

//   const hasFetched = useRef(false);

//   const [loading, setLoading] = useState(false);
//   const [data, setData] = useState(null);

//   const userId = useSelector((state) => state.user?.userData?.id) || "";

//   /* ================================
//      CLEAR CART + STEPPER
//   ================================= */
//   const deleteUserStepperProgress = useCallback(async () => {
//     try {
//       setLoading(true);
//       const payload = {
//         selectedAddress: null,
//         selectedPrescription: null,
//         cartData: [],
//         currentStep: 0,
//       };

//       const res = await apiPUT(
//         `/v1/stepper-progress/update-stepper-progress/${userId}`,
//         payload
//       );

//       if (res.status) {
//         const cartRes = await apiDELETE(`/v1/cart/remove-user-cart`);
//         if (cartRes.status) {
//           dispatch(setCartCount(0));
//         }
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Error clearing cart");
//     } finally {
//       setLoading(false);
//     }
//   }, [userId, dispatch]);

//   /* ================================
//      FETCH ORDER & CLEAR CART
//   ================================= */
//   const fetchOrderToRemoveCart = useCallback(
//     async (orderId) => {
//       try {
//         const orderRes = await apiGET(`${API_URL}/v1/order/${orderId}`);
//         const order = orderRes?.data?.data?.[0];

//         if (order && order.mode !== "enquiry" && order.status !== "paid") {
//           deleteUserStepperProgress();
//         }
//       } catch (error) {
//         console.error(error);
//         toast.error("Failed to fetch order");
//       }
//     },
//     [deleteUserStepperProgress]
//   );

//   /* ================================
//      PAYMENT HISTORY
//   ================================= */
//   const handlePaymentHistory = useCallback(
//     async (paymentIntent) => {
//       try {
//         const params = new URLSearchParams(location.search);
//         const session_id = params.get("session_id");

//         const payload = {
//           userId,
//           amount: paymentIntent?.amount,
//           status: paymentIntent?.status,
//           currency: paymentIntent?.currency,
//           paymentId: paymentIntent?.id,
//           session_id,
//           receipt_email: paymentIntent?.receipt_email,
//           payment_method_types: paymentIntent?.payment_method_types?.[0],
//         };

//         await apiPOST(`${API_URL}/v1/payment-history/add`, payload);
//       } catch (error) {
//         console.error("Payment history error:", error);
//       }
//     },
//     [location.search, userId]
//   );

//   /* ================================
//      SESSION INFO
//   ================================= */
//   const getSessionInfo = useCallback(
//     async (sessionId) => {
//       try {
//         setLoading(true);
//         const res = await apiGET(`/v1/payment/get-session-info/${sessionId}`);

//         if (res.status) {
//           const paymentIntent = res?.data?.data?.paymentIntent;
//           const metadata = res?.data?.data?.metadata;

//           setData(paymentIntent);

//           if (metadata?.orderId) {
//             await fetchOrderToRemoveCart(metadata.orderId);

//             const updatePayload = {
//               mode: metadata.orderMode,
//               orderType: metadata.orderType,
//               status: "paid",
//             };

//             await apiPUT(
//               `${API_URL}/v1/order/update/${metadata.orderId}`,
//               updatePayload
//             );
//           }

//           handlePaymentHistory(paymentIntent);
//         }
//       } catch (error) {
//         console.error(error);
//         toast.error("Error fetching session info");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [fetchOrderToRemoveCart, handlePaymentHistory]
//   );

//   /* ================================
//      INITIAL LOAD
//   ================================= */
//   useEffect(() => {
//     if (hasFetched.current) return;
//     hasFetched.current = true;

//     const params = new URLSearchParams(location.search);
//     const sessionId = params.get("session_id");

//     if (sessionId) {
//       getSessionInfo(sessionId);
//     }
//   }, [location.search, getSessionInfo]);

//   /* ================================
//      FORMAT CURRENCY
//   ================================= */
//   const formatCurrency = (amount, currency) => {
//     const symbols = { usd: "$", inr: "₹" };
//     return `${symbols[currency] || currency?.toUpperCase()}${(
//       amount / 100
//     ).toFixed(2)}`;
//   };

//   /* ================================
//      UI
//   ================================= */
//   return (
//     <div className="flex justify-center items-center p-4 font-poppins mb-5">
//       {loading ? (
//         <div className="animate-spin w-12 h-12 border-4 border-green-600 rounded-full"></div>
//       ) : (
//         <div className=" rounded-lg p-6 bg-gray-200">
//           <div className="md:flex md:space-x-6">
//             <div className="md:w-1/2 bg-white p-6 rounded-lg shadow px-4 py-4">
//               <h2 className="text-2xl font-semibold mb-4">
//                 Payment confirmed successfully!
//               </h2>
//               <p className="text-gray-600 mb-6">
//                 Thank you for your payment. Your transaction is confirmed.
//               </p>
//               <button
//                 onClick={() => navigate("/")}
//                 className="flex items-center bg-green-600 text-white py-2 px-4 rounded-lg"
//               >
//                 <BiArrowBack className="mr-2" /> Go back to home
//               </button>
//             </div>

//             <div className="md:w-1/2 mt-6 md:mt-0 bg-white p-6 rounded-lg shadow">
//               <h2 className="text-2xl font-semibold text-center mb-4">
//                 {data && formatCurrency(data.amount, data.currency)}
//               </h2>
//               <p className="text-green-600 text-center mb-6">
//                 Payment Success!
//               </p>

//               <div>
//                 <p>Date: {data && new Date(data.created * 1000).toLocaleString()}</p>
//                 <p>Reference: {data?.id}</p>
//                 <p>Amount: {data && formatCurrency(data.amount, data.currency)}</p>
//                 <p>Status: <span className="text-green-600">Success</span></p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PaymentSuccess; 


import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { apiGET, apiPUT, apiDELETE } from "../utilities/apiHelpers";
import { setCartCount } from "../redux/users/users";
import { API_URL } from "../config";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const hasFetched = useRef(false);

  const [loading, setLoading] = useState(false);

  // Data passed from PaymentStep via navigate state:
  // navigate(`/success?orderId=${orderId}`, { state: { paymentData: verifyResponse.data.data } })
  const [paymentData] = useState(location.state?.paymentData || null);

  const userId = useSelector((state) => state.user?.userData?.id) || "";

  /* ================================
     CLEAR CART + STEPPER
  ================================= */
  const deleteUserStepperProgress = useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiPUT(
        `/v1/stepper-progress/update-stepper-progress/${userId}`,
        { selectedAddress: null, selectedPrescription: null, cartData: [], currentStep: 0 }
      );
      if (res.status) {
        const cartRes = await apiDELETE(`/v1/cart/remove-user-cart`);
        if (cartRes.status) dispatch(setCartCount(0));
      }
    } catch (error) {
      console.error(error);
      toast.error("Error clearing cart");
    } finally {
      setLoading(false);
    }
  }, [userId, dispatch]);

  /* ================================
     FETCH ORDER & CLEAR CART
  ================================= */
const fetchOrderToRemoveCart = useCallback(async (orderId) => {
  console.log("Fetching order to determine cart cleanup for orderId:", orderId);
    try {
      const orderRes = await apiGET(`${API_URL}/v1/order/${orderId}`);
      const order = orderRes?.data?.data?.[0]; 

      console.log("Fetched order for cart cleanup:", order);

      // ✅ Only skip if enquiry mode, don't check status
      if (order && order.mode !== "enquiry") {
        await deleteUserStepperProgress();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch order");
    }
}, [deleteUserStepperProgress]);

  /* ================================
     INITIAL LOAD
     REMOVED:
       - getSessionInfo()       → Stripe only
       - handlePaymentHistory() → backend handles in verifyPayment
       - apiPUT order/update    → backend handles in verifyPayment
     KEPT:
       - fetchOrderToRemoveCart → still needed to clear cart
  ================================= */
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const params = new URLSearchParams(location.search);
    const orderId = params.get("orderId");
    const targetOrderId = paymentData?.orderId || orderId;

    if (targetOrderId) {
      fetchOrderToRemoveCart(targetOrderId);
    }
  }, [location.search, paymentData, fetchOrderToRemoveCart]);

  /* ================================
     HELPERS
  ================================= */
  const formatINR = (paiseAmount) => {
    if (!paiseAmount) return "₹0.00";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(paiseAmount / 100);
  };

  const formatDate = (unixTs) => {
    if (!unixTs) return "—";
    return new Date(unixTs * 1000).toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  };

  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "—";

  // Shorthand refs from verifyPayment response:
  // { paymentDetails, orderId, metadata: { razorpay_order_id, razorpay_payment_id } }
  const pd   = paymentData?.paymentDetails;
  const meta = paymentData?.metadata;
  const orderId = paymentData?.orderId;

  /* ================================
     UI
  ================================= */
  return (
    <div className="flex justify-center items-center p-4 font-poppins mb-5">
      {loading ? (
        <div className="animate-spin w-12 h-12 border-4 border-green-600 rounded-full border-t-transparent" />
      ) : (
        <div className="rounded-lg p-6 bg-gray-200 w-full max-w-4xl">
          <div className="md:flex md:space-x-6">

            {/* ── Left: Confirmation ── */}
            <div className="md:w-1/2 bg-white p-6 rounded-lg shadow">
              <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h2 className="text-2xl font-semibold mb-4">
                Payment confirmed successfully!
              </h2>
              <p className="text-gray-600 mb-6">
                Thank you for your payment. Your transaction is confirmed.
              </p>
              <div className="flex gap-3 flex-wrap">
                <button
                  onClick={() => navigate("/")}
                  className="flex items-center bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition"
                >
                  <BiArrowBack className="mr-2" /> Go back to home
                </button>
                <button
                  onClick={() => navigate("/orders")}
                  className="flex items-center border border-green-600 text-green-600 py-2 px-4 rounded-lg hover:bg-green-50 transition"
                >
                  My Orders
                </button>
              </div>
            </div>

            {/* ── Right: Payment Details ── */}
            <div className="md:w-1/2 mt-6 md:mt-0 bg-white p-6 rounded-lg shadow">
              <h2 className="text-2xl font-semibold text-center mb-1">
                {formatINR(pd?.amount)}
              </h2>
              <p className="text-green-600 text-center mb-6">✓ Payment Success!</p>

              <div className="space-y-3 text-sm">

                {pd?.id && (
                  <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Payment ID</span>
                    <span className="font-mono text-xs font-medium">{pd.id}</span>
                  </div>
                )}

                {meta?.razorpay_order_id && (
                  <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Order ID</span>
                    <span className="font-mono text-xs font-medium">{meta.razorpay_order_id}</span>
                  </div>
                )}

                {orderId && (
                  <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Reference</span>
                    <span className="font-mono text-xs font-medium">{orderId}</span>
                  </div>
                )}

                {pd?.method && (
                  <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Method</span>
                    <span className="font-medium">
                      {capitalize(pd.method)}{pd.wallet ? ` (${capitalize(pd.wallet)})` : ""}
                    </span>
                  </div>
                )}

                {pd?.created_at && (
                  <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Date</span>
                    <span className="font-medium">{formatDate(pd.created_at)}</span>
                  </div>
                )}

                {pd?.email && (
                  <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Email</span>
                    <span className="font-medium truncate max-w-[60%]">{pd.email}</span>
                  </div>
                )}

                {pd?.contact && (
                  <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Contact</span>
                    <span className="font-medium">{pd.contact}</span>
                  </div>
                )}

                {pd?.amount && (
                  <div className="flex justify-between border-b pb-2">
                    <span className="text-gray-500">Amount</span>
                    <span className="font-medium">{formatINR(pd.amount)}</span>
                  </div>
                )}

                <div className="flex justify-between pb-2">
                  <span className="text-gray-500">Status</span>
                  <span className="font-medium text-green-600">Success</span>
                </div>

                {/* Fee Breakdown */}
                {/* {(pd?.fee || pd?.tax) && (
                  <div className="bg-gray-50 rounded-lg p-3 mt-2">
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">
                      Fee Breakdown
                    </p>
                    {pd?.fee && (
                      <div className="flex justify-between text-xs mb-1">
                        <span className="text-gray-500">Gateway Fee</span>
                        <span>{formatINR(pd.fee)}</span>
                      </div>
                    )}
                    {pd?.tax && (
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-500">Tax (GST)</span>
                        <span>{formatINR(pd.tax)}</span>
                      </div>
                    )}
                  </div>
                )} */}

              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;
